module.exports = __webpack_public_path__ + "img/btn-email.17ffc231.png";